import { registerMessages } from "../../../i18n/runtime";
import { operationsEn } from "./messages.en";
import { operationsEs } from "./messages.es";
registerMessages("en", operationsEn);
registerMessages("es", operationsEs);
